import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'lt',
  Pagination: {
    items_per_page: '/ psl.',
    jump_to: 'Pereiti',
    jump_to_confirm: 'patvirtinti',
    page: '',
    prev_page: 'Atgal',
    next_page: 'Pirmyn',
    prev_5: 'Grįžti 5 pls.',
    next_5: 'Peršokti 5 pls.',
    prev_3: 'Grįžti 3 pls.',
    next_3: 'Peršokti 3 pls.',
  },
  DatePicker: {
    lang: {
      placeholder: 'Pasirinkite datą',
      yearPlaceholder: 'Pasirinkite metus',
      quarterPlaceholder: 'Pasirinkite ketvirtį',
      monthPlaceholder: 'Pasirinkite mėnesį',
      weekPlaceholder: 'Pasirinkite savaitę',
      rangePlaceholder: [
        'Pradžios data',
        'Pabaigos data',
      ],
      rangeYearPlaceholder: [
        'Pradžios metai',
        'Pabaigos metai',
      ],
      rangeMonthPlaceholder: [
        'Pradžios mėnesis',
        'Pabaigos mėnesis',
      ],
      rangeWeekPlaceholder: [
        'Pradžios savaitė',
        'Pabaigos savaitė',
      ],
      locale: 'lt_LT',
      today: 'Šiandien',
      now: 'Dabar',
      backToToday: 'Rodyti šiandien',
      ok: 'Gerai',
      clear: 'Išvalyti',
      month: 'Mėnesis',
      year: 'Metai',
      timeSelect: 'Pasirinkti laiką',
      dateSelect: 'Pasirinkti datą',
      monthSelect: 'Pasirinkti mėnesį',
      yearSelect: 'Pasirinkti metus',
      decadeSelect: 'Pasirinkti dešimtmetį',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY-MM-DD HH:MM:SS',
      monthBeforeYear: true,
      previousMonth: 'Buvęs mėnesis (PageUp)',
      nextMonth: 'Sekantis mėnesis (PageDown)',
      previousYear: 'Buvę metai (Control + left)',
      nextYear: 'Sekantis metai (Control + right)',
      previousDecade: 'Buvęs dešimtmetis',
      nextDecade: 'Sekantis dešimtmetis',
      previousCentury: 'Buvęs amžius',
      nextCentury: 'Sekantis amžius',
    },
    timePickerLocale: {
      placeholder: 'Pasirinkite laiką',
      rangePlaceholder: [
        'Pradžios laikas',
        'Pabaigos laikas',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Pasirinkite laiką',
    rangePlaceholder: [
      'Pradžios laikas',
      'Pabaigos laikas',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Pasirinkite datą',
      yearPlaceholder: 'Pasirinkite metus',
      quarterPlaceholder: 'Pasirinkite ketvirtį',
      monthPlaceholder: 'Pasirinkite mėnesį',
      weekPlaceholder: 'Pasirinkite savaitę',
      rangePlaceholder: [
        'Pradžios data',
        'Pabaigos data',
      ],
      rangeYearPlaceholder: [
        'Pradžios metai',
        'Pabaigos metai',
      ],
      rangeMonthPlaceholder: [
        'Pradžios mėnesis',
        'Pabaigos mėnesis',
      ],
      rangeWeekPlaceholder: [
        'Pradžios savaitė',
        'Pabaigos savaitė',
      ],
      locale: 'lt_LT',
      today: 'Šiandien',
      now: 'Dabar',
      backToToday: 'Rodyti šiandien',
      ok: 'Gerai',
      clear: 'Išvalyti',
      month: 'Mėnesis',
      year: 'Metai',
      timeSelect: 'Pasirinkti laiką',
      dateSelect: 'Pasirinkti datą',
      monthSelect: 'Pasirinkti mėnesį',
      yearSelect: 'Pasirinkti metus',
      decadeSelect: 'Pasirinkti dešimtmetį',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY-MM-DD HH:MM:SS',
      monthBeforeYear: true,
      previousMonth: 'Buvęs mėnesis (PageUp)',
      nextMonth: 'Sekantis mėnesis (PageDown)',
      previousYear: 'Buvę metai (Control + left)',
      nextYear: 'Sekantis metai (Control + right)',
      previousDecade: 'Buvęs dešimtmetis',
      nextDecade: 'Sekantis dešimtmetis',
      previousCentury: 'Buvęs amžius',
      nextCentury: 'Sekantis amžius',
    },
    timePickerLocale: {
      placeholder: 'Pasirinkite laiką',
      rangePlaceholder: [
        'Pradžios laikas',
        'Pabaigos laikas',
      ],
    },
  },
  Table: {
    filterTitle: 'Filtras',
    filterConfirm: 'Gerai',
    filterReset: 'Atstatyti',
    filterEmptyText: 'Be filtrų',
    emptyText: 'Nėra duomenų',
    selectAll: 'Pasirinkti viską',
    selectInvert: 'Apversti pasirinkimą',
    selectionAll: 'Rinktis visus',
    sortTitle: 'Rikiavimas',
    expand: 'Išskleisti',
    collapse: 'Suskleisti',
    triggerDesc: 'Spustelėkite norėdami rūšiuoti mažėjančia tvarka',
    triggerAsc: 'Spustelėkite norėdami rūšiuoti didėjančia tvarka',
    cancelSort: 'Spustelėkite, kad atšauktumėte rūšiavimą',
  },
  Modal: {
    okText: 'Taip',
    cancelText: 'Atšaukti',
    justOkText: 'Gerai',
  },
  Popconfirm: {
    okText: 'Taip',
    cancelText: 'Atšaukti',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Paieška',
    itemUnit: 'vnt.',
    itemsUnit: 'vnt.',
    remove: 'Pašalinti',
    selectAll: 'Pasirinkti visus',
    selectCurrent: 'Pasirinkite dabartinį puslapį',
    selectInvert: 'Atkeist pasirinkimą',
    removeAll: 'Ištrinti visus duomenis',
    removeCurrent: 'Ištrinti dabartinį puslapį',
  },
  Upload: {
    uploading: 'Gaunami duomenys...',
    removeFile: 'Ištrinti failą',
    uploadError: 'Įkeliant įvyko klaida',
    previewFile: 'Failo peržiūra',
    downloadFile: 'Įkelti failą',
  },
  Empty: {
    description: 'Nėra duomenų',
  },
  Icon: {
    icon: 'piktograma',
  },
  Text: {
    edit: 'Redaguoti',
    copy: 'Kopijuoti',
    copied: 'Nukopijuota',
    expand: 'Plačiau',
  },
  PageHeader: {
    back: 'Atgal',
  },
  Form: {
    defaultValidateMessages: {
      default: 'Laukelio klaida ${label}',
      required: 'Prašome įvesti ${label}',
      enum: '${label} turėtu būti vienas iš [${enum}]',
      whitespace: '${label} negali likti tuščiu',
      date: {
        format: '${label} neteisingas datos formatas',
        parse: '${label} negali būti konvertuotas į datą',
        invalid: '${label} neatitinka datos formato',
      },
      types: {
        string: '${label} не является типом ${type}',
        method: '${label} не является типом ${type}',
        array: '${label} не является типом ${type}',
        object: '${label} не является типом ${type}',
        number: '${label} не является типом ${type}',
        date: '${label} не является типом ${type}',
        boolean: '${label} не является типом ${type}',
        integer: '${label} не является типом ${type}',
        float: '${label} не является типом ${type}',
        regexp: '${label} не является типом ${type}',
        email: '${label} не является типом ${type}',
        url: '${label} не является типом ${type}',
        hex: '${label} не является типом ${type}',
      },
      string: {
        len: '${label} turi būti ${len} simbolių',
        min: '${label} turi būti ilgesnis nei ${min} simbolių',
        max: '${label} turi būti ne trumpesnis ${max} simbolių',
        range: 'Lauko ${label} reikšmės ribos ${min}-${max} simbolių',
      },
      number: {
        len: '${label} turi būti lygi ${len}',
        min: '${label} turi būti lygus arba didesnis ${min}',
        max: '${label} turi būti lygus arba mažesnis ${max}',
      },
      array: {
        len: 'Pasirinktas kiekis ${label} turi būti lygus ${len}',
        min: 'Pasirinktas kiekis ${label} turi būti lygus arba didesnis ${min}',
        max: 'Pasirinktas kiekis ${label} turi būti lygus arba mažesnis ${max}',
        range: 'Pasirinktas kiekis ${label} turi būti tarp ${min} и ${max}',
      },
      pattern: {
        mismatch: '${label} neatitinka modelio ${pattern}',
      },
    },
  },
};

export default localeValues;
